module.exports = __webpack_public_path__ + "static/media/nessa.1b03a2fc.png";